/* eslint-disable max-len */
/** 语言类型 */
export enum LanguageType {
    zhCN = 'zh-CN',
    enUS = 'en-US',
}
export enum SubtitlesTypeEnum {
    NOTITLE = 1,
    WITHTITLE = 2,
}
